



































import {Component, Prop, Vue} from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
@Component({
	components: {
		Multiselect
	}
})
export default class MultiSelectPicker extends Vue {
	@Prop() public options: any[];
	@Prop() public value: any[];
	@Prop() public idAttribute: string;
	@Prop() public displayAttribute: string;
	@Prop({default: ''}) public tooltip: string;
	@Prop({default: 'right'}) public dropdownAlignment: 'left' | 'right';

	public onInput(newValue: any[]) {
		this.updateDisabledStateOfItems(newValue);
		// order selected columns based on order of original column list
		const orderedSelectedColumns = this.options.filter(c => newValue.findIndex(v => this.getIdValue(v) === this.getIdValue(c)) !== -1);
		this.$emit('input', orderedSelectedColumns);
	}

	public getDisplayLabel(option: any) {
		return option[this.displayAttribute];
	}

	public isOptionSelected(option: any) {
		return this.value.some(c => this.getIdValue(c) === this.getIdValue(option));
	}

	public isLastOptionSelected(name: string) {
		return this.isOptionSelected(name) && this.value.length === 1;
	}

	private updateDisabledStateOfItems(selectedOptions: any[]) {
		// if only one option is selected, disable it so 1 selection is required
		if (selectedOptions.length === 1) {
			const lastItem = this.options.find(c => this.getIdValue(c) === this.getIdValue(selectedOptions[0]));
			if (lastItem) {
				(lastItem as any).$isDisabled = true;
			}
		} else {
			this.options.forEach(c => (c as any).$isDisabled = false);
		}
	}

	private getIdValue(option: any) {
		return option[this.idAttribute];
	}
}
